// 科普接口 data 字段映射；缺失数据保持为空，不补造名称或统计值。
export const SCIENCE_CHART_TYPES = [
    { field: 'therapy', title: '疗法' },
    { field: 'acupunctureTherapy', title: '针灸疗法' },
    { field: 'acupoint', title: '穴位' },
    { field: 'meridian', title: '经络' },
    { field: 'medicationContraindication', title: '用药禁忌' },
];
export const SCIENCE_TAG_TYPES = [
    { field: 'tcmHealthPreservation', title: '中医养生保健' },
    { field: 'massage', title: '按摩' },
    { field: 'food', title: '食品' },
];
const asArray = (value) => Array.isArray(value) ? value : [];
const graphData = (value) => ({ nodes: asArray(value && value.nodes), edges: asArray(value && value.edges) });

export function normalizeScienceData(value) {
    const data = value || {};
    const sankey = data.symptomSankey || {};
    const result = {
        diseaseName: data.diseaseName || '',
        top10DoctorRecommendation: asArray(data.top10DoctorRecommendation)
            .filter((item) => item && item.name)
            .map((item) => ({ name: item.name, result: graphData(item.result) })),
        nursingKnowledgeGraph: graphData(data.nursingKnowledgeGraph),
        symptomKnowledgeGraph: graphData(data.symptomKnowledgeGraph),
        symptomSankey: { data: asArray(sankey.data), links: asArray(sankey.links) },
    };
    SCIENCE_CHART_TYPES.forEach(({ field }) => {
        result[field] = asArray(data[field]).filter((item) => item && item.name);
    });
    SCIENCE_TAG_TYPES.forEach(({ field }) => {
        result[field] = asArray(data[field]).filter((item) => typeof item === 'string' && item.trim());
    });
    return result;
}
